module.exports = __webpack_public_path__ + "img/dx.2650e55b.png";